import { ChartOptions, TickOptions } from "chart.js";
import classNames from "classnames";
import { Bar, Line, Pie } from "react-chartjs-2";
import { transformData } from "utils";

interface ICustomChart {
  chartData: any;
  chartType: string;
  title: string;
}

enum Position {
  bottom = "bottom",
  top = "top",
  left = "left",
  right = "right",
}

function CustomChartPdf(props: ICustomChart) {
  const { chartData, chartType = "pie_chart", title } = props;

  const data = typeof chartData === "string" ? JSON.parse(chartData) : chartData;
  const transformedData = transformData(data);

  console.log(transformedData, "transformedData");

  const { labels, datasets } = transformedData;

  console.log(datasets[0].backgroundColor, "datasets");

  const colors = datasets[0]?.backgroundColor;

  const chartIndex = datasets[0]?.data;

  const tableData = labels.map((label, index) => {
    const colorIndex = index % colors.length;
    return {
      label: label,
      color: colors[colorIndex],
      data: chartIndex[colorIndex],
    };
  });

  const options: ChartOptions<"bar" | "pie" | "line"> = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: title,
        position: Position.bottom,
      },
    },
    scales:
      chartType === "pie_chart"
        ? undefined
        : {
            x: {
              ticks: {
                callback: function (value: number | string, index: number) {
                  const label = this.getLabelForValue(index);
                  return label.length > 10 ? label.substring(0, 10) + "..." : label;
                },
              },
            },
          },
  };

  const columns = ["Label", "Data", "Color"];


  return (
    <div
      className={classNames("w-full relative pt-6", {
        "aspect-square": chartType === "pie_chart",
      })}
    >
      <>
        {chartType === "bar_chart" && <Bar data={transformedData} options={options} />}
        {chartType === "pie_chart" && <Pie data={transformedData} options={options} />}
        {chartType === "line_chart" && <Line data={transformedData} options={options as any} />}
          <div className="mt-4">
            <table>
              <thead>
                <tr style={{ backgroundColor: "#f3f4f6", color: "#111827" }}>
                  {columns.map((header: string) => (
                    <th key={header} style={{ border: "1px solid #787a7e", padding: "8px" }} className="capitalize">
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tableData.map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      transition: "background-color 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f0f0")}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "")}
                  >
                    <td style={{ border: "1px solid #787a7e", padding: "8px" }}>{item.label}</td>
                    <td style={{ border: "1px solid #787a7e", padding: "8px" }}>{item.data}</td>
                    <td style={{ border: "1px solid #787a7e", padding: "8px" }}>
                      <div style={{ backgroundColor: item.color, width: "100%", height: "30px", borderRadius: "6px" }}></div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
      </>
    </div>
  );
}

export default CustomChartPdf;
